module.exports = __webpack_public_path__ + "static/media/bnr4.3e559348.jpg";